<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headersTmp"
      :items="items"
      :item-key="itemKey"
      :hide-default-header="false"
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:[`header.purchasePriceAndUnitName`]>
        <div class="text-center">
          <div>{{ $t('product.product_purchase-price') }}</div>
          <div>（{{ selectCurrency.name }}）</div>
        </div>
      </template>
      <template v-slot:[`header.priceAndUnitName`]>
        <div class="text-center">
          <div>{{ $t('sale.sale_unit-price') }}</div>
          <div>（{{ selectCurrency.name }}）</div>
        </div>
      </template>
      <template v-slot:[`header.exportSubjectFlg`]>
        <HelpCircle size="small">
          <div class="font-weight-bold exportSubjectFlg">
            <div>{{ $t('sale.sale_exporter-table-style-first-line') }}</div>
            <div>{{ $t('sale.sale_exporter-table-style-last-line') }}</div>
          </div>
          <template #explanation>
            <span class="exporterExplanation"
              >{{ $t('sale.sale_exporter-explanation') }}
            </span></template
          >
        </HelpCircle>
      </template>
      <template v-slot:[`header.quantityAndStorageNo`]="item">
        <HelpCircle
          v-if="'input' in item.header && item.header.input"
          size="small"
        >
          <div class="font-weight-bold exportSubjectFlg">
            {{ $t(item.header.text) }}
          </div>
          <template #explanation>
            {{ $t('sale.sale_loading-quantity-explanation') }}
          </template>
        </HelpCircle>
        <span v-else>{{ $t(item.header.text) }}</span>
      </template>
      <template v-slot:[`header.checkbox`]>
        <div class="productTableCom-header-checkbox">
          <v-checkbox
            v-model="isCheckedAllSelected"
            @change="allCheckProductTable"
          />
        </div>
      </template>

      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td :colspan="headersTmp.length" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>

          <tr
            v-for="(item, trIndex) in items"
            :key="`group-${trIndex}`"
            :class="{
              tdStyleDisabled: getDisabled(item.product, 'disabledFlg')
            }"
          >
            <template v-for="(header, index) in headersTmp">
              <td
                v-bind:class="{
                  tdStyleCenter: getAlign(header.value) === 'center',
                  tdStyleEnd: getAlign(header.value) === 'end',
                  DisplayNone: getAlign(header.value) === ' d-none',
                  invalidRec: isInvalid(item[itemKey]),
                  textRed:
                    getHeaderValue(header.value) === 'refundPrice' ||
                    getHeaderValue(header.value) === 'refundAmount',
                  refundAmountColor:
                    isRefund === true &&
                    getHeaderValue(header.value) === 'amount'
                }"
                :key="index"
              >
                <!-- {{ header.value }} -->
                <slot :name="header.value" v-bind:item="item">
                  <div v-if="isName(header, 'invalid')">
                    <v-checkbox
                      v-model="checkbox"
                      :value="item[itemKey]"
                    ></v-checkbox>
                  </div>

                  <!-- productMoves -->
                  <div v-else-if="isName(header, 'productName')">
                    {{ item.product.nameJp }} <br />
                    {{ item.product.nameCn }}
                  </div>
                  <div v-else-if="isName(header, 'exportSubjectFlg')">
                    {{
                      item.exportSubjectFlg
                        ? $t('sale.sale_exporter-table-style-last-line')
                        : ''
                    }}
                  </div>
                  <div v-else-if="isName(header, 'price')">
                    {{ createPrice(item.price, item.currencyId) }}
                  </div>
                  <div v-else-if="isName(header, 'refundPrice')">
                    {{
                      createRefundPrice(item.refundPrice, item.refundCurrencyId)
                    }}
                  </div>

                  <!-- product -->
                  <div v-else-if="isName(header, 'productInfoAndCapacity')">
                    {{ item.nameJp }} <br />
                    <div v-if="item.nameCn">{{ item.nameCn }} <br /></div>
                    {{ item.capacity }}
                  </div>
                  <div v-else-if="isName(header, 'productExpiredDate')">
                    {{ getDatefromDateTime(item.productExpiredDate) }}
                  </div>
                  <!-- storage -->
                  <div v-else-if="isName(header, 'quantityAndStorageNo')">
                    <div
                      v-for="(rack, racIdx) in item.loadingMoveDetails"
                      :key="racIdx"
                    >
                      {{ createRackNumbers(rack) }}
                    </div>
                  </div>
                  <div
                    v-else-if="isName(header, 'quantityAndStorageNoForShip')"
                  >
                    <div
                      v-for="(rack, racIdx) in createRackNumbersForShipHistory(
                        item
                      )"
                      :key="racIdx"
                    >
                      {{ `${rack.quantity}（${rack.rackNumber} ）` }}
                    </div>
                  </div>
                  <div
                    v-else-if="
                      isName(header, 'quantityAndStorageNoForStockAdjust') &&
                      item.quantity > 0
                    "
                  >
                    <div
                      v-for="(rack, racIdx) in item.loadingMoveDetails"
                      :key="racIdx"
                    >
                      {{ createRackNumbers(rack) }}
                    </div>
                  </div>
                  <div
                    v-else-if="
                      isName(header, 'quantityAndStorageNoForStockAdjust') &&
                      item.quantity < 0
                    "
                  >
                    <div
                      v-for="(rack, racIdx) in createRackNumbersForShipHistory(
                        item
                      )"
                      :key="racIdx"
                    >
                      {{ `-${rack.quantity}（${rack.rackNumber} ）` }}
                    </div>
                  </div>
                  <!-- supplier -->
                  <div v-else-if="isName(header, 'supplier')">
                    {{ getSupplierName(item.product.supplier) }}
                  </div>
                  <!-- supplier -->
                  <div v-else-if="isName(header, 'product.supplierId')">
                    {{ getSupplierNameById(item.product.supplierId) }}
                  </div>

                  <!-- common -->
                  <div
                    v-else-if="
                      isName(header, 'taxId') || isName(header, 'product.taxId')
                    "
                  >
                    {{ getTaxValue(getRowValue(item, header.value)) }}
                  </div>
                  <div v-else-if="isName(header, 'product.disabledFlg')">
                    {{
                      item.product.disabledFlg
                        ? $t('order.order_invalid')
                        : $t('common.common_normal')
                    }}
                  </div>
                  <div
                    v-else-if="
                      itemKey === 'product.productNumber' &&
                      isName(header, 'amount')
                    "
                  >
                    <!-- {{ createLabel(item.price * item.quantity, header) }} -->
                    {{
                      tableKey === 'orderId'
                        ? maskText(
                            createPrice(
                              item.price * item.quantity,
                              item.currencyId
                            ),
                            authority.isAdmin || authority.isUser
                          )
                        : tableKey === 'saleId'
                        ? maskText(
                            createPrice(
                              item.price * item.quantity,
                              item.currencyId
                            ),
                            authority.isAdmin ||
                              authority.isUser ||
                              authority.isPartTime
                          )
                        : createPrice(
                            item.price * item.quantity,
                            item.currencyId
                          )
                    }}
                  </div>
                  <div v-else-if="isName(header, 'refundAmount')">
                    <!-- {{ createLabel(item.price * item.quantity, header) }} -->
                    {{
                      createRefundPrice(
                        item.refundPrice * item.quantity,
                        item.refundCurrencyId
                      )
                    }}
                  </div>
                  <!-- stock-adjust -->
                  <div v-else-if="isName(header, 'adjustAfterStockCost')">
                    {{
                      authority.isOutsideStaff
                        ? maskText(
                            adjustAfterStockCost(
                              item.quantity,
                              item.price,
                              item.currencyId
                            ),
                            authority.isAdmin ||
                              authority.isUser ||
                              authority.isPartTime
                          )
                        : adjustAfterStockCost(
                            item.quantity,
                            item.price,
                            item.currencyId
                          )
                    }}
                  </div>
                  <div v-else>
                    {{ getDefaultValue(item, header) }}
                  </div>
                </slot>
              </td>
            </template>
          </tr>
        </tbody>
      </template>
      <template v-slot:footer="{ items }">
        <div
          v-if="isRegistedOtherProduct"
          class="product-table-column-registed"
        >
          {{ $t('common.common_registed-other-product') }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HelpCircle from '@/components/items/Buttons/HelpCircle'
import {
  commonUtil,
  currencyUtil,
  consumptionTaxUtil,
  supplierUtil
} from '@/util'

export default {
  name: 'ProductTable',

  components: {
    HelpCircle
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({
        // checkbox: {
        //   type: Array,
        //   require: true,
        //   default: () => []
        // }
      })
    },
    headers: [],
    items: [],
    itemKey: String,
    search: { default: '' },
    productKey: String,
    tableKey: String,
    isRoundedLg: { default: false },
    selectCurrency: { default: '' },
    isRefund: { default: false },
    isCheckedAllSelect: { default: false },
    isRegistedOtherProduct: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    itemsDetail: [],
    checkbox: [],
    isCheckedAllSelected: false
  }),
  async created() {
    this.createHeaders()
  },
  computed: {
    ...mapGetters('User', ['authority']),
    headersTmp() {
      const headersTmp = this.headers.map((header) => {
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        delete tmp.inputType
        delete tmp.unit
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    createHeaders() {
      this.itemsDetail = this.headers.map((header) => {
        return {
          value: header.value,
          inputType: 'inputType' in header ? header.inputType : '',
          unit: 'unit' in header ? header.unit : '',
          currencyIdName:
            'currencyIdName' in header ? header.currencyIdName : '',
          align: 'align' in header ? header.align : ''
        }
      })
    },
    isName(header, name) {
      return header.value === name
    },
    getRowValue(obj, path) {
      let tmp = this.getValue(obj, path)
      return typeof tmp === 'undefined' ? '' : tmp
    },
    getValue(obj, path) {
      if (!path) return obj
      const properties = path.split('.')
      return this.getValue(obj[properties.shift()], properties.join('.'))
    },
    getItemsDetailRecord(value) {
      return this.itemsDetail.find((header) => header.value === value)
    },
    getInputType(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.inputType : ''
    },
    getUnit(item, header) {
      const tmp = this.getItemsDetailRecord(header.value)
      if (!tmp.currencyIdName) return ''

      const currencyId = item[tmp.currencyIdName]
      return currencyUtil.findCurrencyNameById(currencyId).unitName
    },
    getDisabled(item, key) {
      if (!item || !(key in item)) return
      return item[key] || false
    },
    getAlign(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.align : ''
    },
    getHeaderValue(value) {
      const tmp = this.getItemsDetailRecord(value)
      return tmp ? tmp.value : ''
    },
    createPrice(price, currencyId) {
      return (
        commonUtil.formatPrice(price).toLocaleString() +
        currencyUtil.findCurrencyNameById(currencyId).unitName
      )
    },
    createRefundPrice(price, currencyId) {
      const tmpPrice = price * -1
      return (
        commonUtil.formatPrice(tmpPrice).toLocaleString() +
        currencyUtil.findCurrencyNameById(currencyId).unitName
      )
    },

    isInvalid(id) {
      if (!this.checkbox.length) return false

      return this.checkbox.find((ele) => id == ele)
    },
    getTaxValue(id) {
      return consumptionTaxUtil.getConsumptionTaxIdInfo(id)
    },
    getDatefromDateTime(datetime) {
      const date = commonUtil.getDateFromDateTimeString(datetime)
      return commonUtil.nullEmptyFormatHyphen(date)
    },
    formatHyphen(str) {
      return commonUtil.nullEmptyFormatHyphen(str)
    },
    createRackNumbers(rack) {
      const rackNumber = rack.rackNumber
        ? rack.rackNumber
        : this.$t('common.common_no-rack-number')
      return rack.loadingQuantity + '（' + rackNumber + '）'
    },
    createRackNumbersForShipHistory(productMove) {
      const rackNumberList = []
      productMove.loadingShipRelations.forEach((ele) => {
        const tmp = rackNumberList.find(
          (ele2) =>
            ele2.rackNumber == ele.loadingMoveDetail.rackNumber ||
            (!ele2.rackNumber && !ele.loadingMoveDetail.rackNumber)
        )
        if (tmp) {
          tmp.quantity += ele.shipQuantity
        } else {
          rackNumberList.push({
            rackNumber: ele.loadingMoveDetail.rackNumber,
            quantity: ele.shipQuantity
          })
        }
      })
      return rackNumberList.map((ele) => {
        if (!ele.rackNumber)
          ele.rackNumber = this.$t('common.common_no-rack-number')
        return ele
      })
    },
    getDefaultValue(item, header) {
      const val = this.getRowValue(item, header.value)
      return val ? val + this.getUnit(item, header) : '-'
    },
    getSupplierName(supplier) {
      const description = supplier.description
        ? `【${supplier.description}】`
        : ''
      return supplier.abbreviation + description
    },
    getSupplierNameById(supplierId) {
      const supplier = supplierUtil.getSupplierBySupplierId(supplierId)
      return this.getSupplierName(supplier)
    },
    allCheckProductTable() {
      this.$emit('allCheckProductTable')
    },
    adjustAfterStockCost(quantity, price, currencyId) {
      if (quantity < 0) {
        return '-'
      }
      return (
        commonUtil.formatPrice(price).toLocaleString() +
        currencyUtil.findCurrencyNameById(currencyId).unitName
      )
    }
  },
  watch: {
    isCheckedAllSelect(n) {
      this.isCheckedAllSelected = n
    },
    checkbox: function (val) {
      this.$emit('changeInvalid', this.checkbox)
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    // border: solid 1px #d8d8d8;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: #fff;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;

    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
  }

  .tdStyleDisabled {
    opacity: 0.6;
    td {
      background-color: transparent !important;
    }
  }
  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .DisplayNone {
    display: none;
  }
  .invalidRec {
    background-color: #dddddd !important;
  }
  .exportSubjectFlg {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
  }
  .textRed {
    color: red;
  }
  .refundAmountColor {
    color: red;
  }

  &-header-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .product-table-column-registed {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
  }
}
.exporterExplanation {
  white-space: pre-line;
}
</style>
